import { useEffect, useRef } from "react"

const EXCLUDED_KEYS = ["sobreGarantia"]

const normalizeText = (value) =>
    `${value || ""}`.trim().toLowerCase()

export const useGarantiasValorDefault = (
    garantiasState,
    setGarantiasState
) => {
    const prevStateRef = useRef(garantiasState)

    useEffect(() => {
        const prev = prevStateRef.current
        prevStateRef.current = garantiasState

        const updates = {}

        Object.keys(garantiasState).forEach((key) => {
            // ignora checkbox e valor
            if (key.endsWith("Check") || key.endsWith("Valor")) return
            if (EXCLUDED_KEYS.includes(key)) return

            const checkKey = `${key}Check`
            const valorKey = `${key}Valor`

            const wasChecked = Boolean(prev?.[checkKey])
            const isChecked = Boolean(garantiasState[checkKey])

            const textChanged =
                prev?.[key] !== garantiasState[key]

            // só reage se checkbox estiver marcado
            if (!isChecked) return

            // só aplica quando texto mudou OU checkbox acabou de ser marcado
            if (!textChanged && wasChecked) return

            // não sobrescreve se usuário já colocou valor
            const currentValor = garantiasState[valorKey]
            if (
                currentValor !== null &&
                currentValor !== undefined &&
                currentValor !== ""
            ) {
                return
            }

            const text = normalizeText(garantiasState[key])

            updates[valorKey] = text === "não tem" ? 0 : 1
        })

        if (Object.keys(updates).length) {
            setGarantiasState((prevState) => ({
                ...prevState,
                ...updates,
            }))
        }
    }, [garantiasState, setGarantiasState])
}
